import axios from '../../../axios';
import GoogleDrive from '../types/GoogleDrive';
import ICalenderEvent from '../types/ICalendarEvent';
import { IEmailEvaluationLink } from '../types/IEmailEvaluationLink';

const url = 'emailingapp/api/google-auth';
const googleAuth = 'api/google-auth';
const driveAccountUrl = 'api/google/drive';

export const getCalendarAccounts = () => axios.get(`${url}/calendar-accounts`);

export const fetchGoogleCalendarEvents = (payload: ICalenderEvent) =>
  axios.post(`${url}/fetch-calendar-events`, payload);

export const updateGoogleCalendarEvent = (payload: ICalenderEvent) =>
  axios.post(`${url}/update-calendar-event`, payload);

export const deleteGoogleCalendarEvent = (payload: ICalenderEvent) =>
  axios.post(`${url}/delete-calendar-event`, payload);

export const createCalendarEvent = (payload: ICalenderEvent) =>
  axios.post(`${url}/create-calendar-event`, payload);

export const initDriveAuth = () => axios.get(`${googleAuth}/drive`);

export const getActiveAccounts = () => axios.get(`${driveAccountUrl}/accounts`);

export const getListOfFoldersInAccount = (payload: GoogleDrive) =>
  axios.post(`${driveAccountUrl}/list/folders`, payload);

export const deleteAccount = (payload: GoogleDrive) =>
  axios.post(`${driveAccountUrl}/account/delete`, payload);

export const importResumeFromDrive = (payload: GoogleDrive) =>
  axios.post(`${driveAccountUrl}/import`, payload);

export const emailEvaluationToAttendees = (payload: IEmailEvaluationLink) =>
  axios.post('/wisestepexternal/api/invite/guest/users', payload);
